import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {RadioButton, RadioButtonGroup} from 'shared/components';
import {Modal, ModalButtons} from 'shared/components/modals';

const RepeatScopeModal = observer(({uiState, isOpen}) => {
  const {repeatScopeRequest} = uiState;
  const deleting = repeatScopeRequest.action === 'delete';

  return (
    <Modal
      isOpen={isOpen}
      onHide={() => uiState.closeRepeatScopeModal()}
      size='sm'
      title={deleting ? 'time_tracking.shifts.Delete Repeating Shift' : 'time_tracking.shifts.Update Repeating Shift'}
    >
      <RadioButtonGroup
        name='repeatScope'
        selectedValue={repeatScopeRequest.scope}
        onChange={(_name, value) => uiState.setRepeatScope(value)}
      >
        <RadioButton value='this'>
          <FormattedMessage id={deleting ? 'time_tracking.shifts.Delete this shift only' : 'time_tracking.shifts.Update this shift only'}/>
          {!deleting && <span className='block jumbo small'><FormattedMessage id='time_tracking.shifts.THIS_SHIFT_ONLY_HELP'/></span>}
        </RadioButton>
        <RadioButton value='future'>
          <FormattedMessage id={deleting ? 'time_tracking.shifts.Delete this shift and all future shifts in the series' : 'time_tracking.shifts.Update this shift and all future shifts in the series'}/>
        </RadioButton>
      </RadioButtonGroup>
      {deleting && uiState.schedule.sendSchedulePublishedNotification && repeatScopeRequest.shift?.published && repeatScopeRequest.shift.employee &&
        <div className='jumbo mb2'>
          <FormattedMessage
            id='time_tracking.shifts.PUBLISHED_SHIFT_DELETED_EMAIL_NOTICE'
            values={{name: repeatScopeRequest.shift.employee.name}}
          />
        </div>
      }
      <ModalButtons
        saveCaption={deleting ? 'time_tracking.shifts.Delete' : 'time_tracking.shifts.Update'}
        trait={deleting ? 'destructive' : 'primary'}
        onSave={() => uiState.confirmRepeatScope()}
        onCancel={() => uiState.closeRepeatScopeModal()}
      />
    </Modal>
  );
});

export default RepeatScopeModal;
